function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoEtl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    style: {},
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 180,
    height: 180,
    rx: 36,
    fill: "#7B9AAE",
    style: {
      fill: "rgb(123, 154, 174)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 100,
    r: 14,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 88,
    x2: 58,
    y2: 112,
    stroke: "white",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52,
    y1: 86,
    x2: 52,
    y2: 114,
    stroke: "white",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 88,
    x2: 46,
    y2: 112,
    stroke: "white",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 100,
    r: 14,
    fill: "none",
    stroke: "white",
    strokeWidth: 2.5,
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "2.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: 88,
    x2: 154,
    y2: 112,
    stroke: "white",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 86,
    x2: 148,
    y2: 114,
    stroke: "white",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142,
    y1: 88,
    x2: 142,
    y2: 112,
    stroke: "white",
    strokeWidth: 1.5,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: "1.5px",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 78,
    y: 84,
    width: 44,
    height: 32,
    rx: 6,
    fill: "white",
    opacity: 0.9,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 0.9,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 105,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fontWeight: 700,
    fill: "#7B9AAE",
    style: {
      fill: "rgb(123, 154, 174)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 11,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "ETL"), /*#__PURE__*/React.createElement("line", {
    x1: 66,
    y1: 100,
    x2: 76,
    y2: 100,
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "72,95 78,100 72,105",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 100,
    x2: 134,
    y2: 100,
    stroke: "white",
    strokeWidth: 2,
    style: {
      fill: "rgb(0, 0, 0)",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "130,95 136,100 130,105",
    fill: "none",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round",
    style: {
      fill: "none",
      stroke: "rgb(255, 255, 255)",
      color: "rgb(255, 255, 255)",
      strokeWidth: 2,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      opacity: 1,
      fontFamily: "&quot",
      fontSize: 16,
      fontWeight: 400,
      textAnchor: "start",
      dominantBaseline: "auto"
    }
  }), /*#__PURE__*/React.createElement("text", {
    x: 100,
    y: 162,
    textAnchor: "middle",
    fontFamily: "Arial, sans-serif",
    fontSize: 12,
    fontWeight: 700,
    fill: "white",
    letterSpacing: 1,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "none",
      color: "rgb(255, 255, 255)",
      strokeWidth: 1,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      opacity: 1,
      fontFamily: "Arial, sans-serif",
      fontSize: 12,
      fontWeight: 700,
      textAnchor: "middle",
      dominantBaseline: "auto"
    }
  }, "INT\xC9GRATION"));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEtl);
export default __webpack_public_path__ + "static/media/Logo_etl.391e3cd05e484d731af4b9240f136fd6.svg";
export { ForwardRef as ReactComponent };